<template>
<div id="application">
    <div id="page"
         if="activeComponent"
         :is="activeComponent"
         :is-superuser="!!session.isSuperuser"
         :is-trial-user="!!session.isTrialUser"
         :is-impersonating="!!session.isImpersonating"
         :impersonating-message="session.impersonatingMessage"
         :class="session.isCustomer ? 'clientView' : 'researcherView'"
    >
    </div>
    <div class="loader-overlay" :class="{visible: isLoaderVisible}">
        <div v-if="isLoaderVisible" class="loader"></div>
    </div>
</div>
</template>

<script>
import AuthComponent from './authenticated.vue';
import AnonymousComponent from './anonymous.vue';
import LoadingComponent from './loading.vue';
import DownComponent from './down.vue';

export default {
    name: 'Application',
    computed: {
        activeComponent,
        session,
        isLoaderVisible
    },
}

function session() {
    return this.$store.state.session || {}
}

function isLoaderVisible() {
    return !!this.$store.state.loader;
}

function activeComponent() {
    const status = this.$route.meta.anonymous ?
        'anonymous' :
        this.$store.getters.status

    const available = {
        authenticated: AuthComponent,
        anonymous: AnonymousComponent,
        loading: LoadingComponent,
        down: DownComponent
    }

    return available[status]
}
</script>
